<div
  [ngClass]="
    playlist.id === selectedId && selected
      ? 'playlist-element'
      : 'playlist-element-hidden'
  "
  (click)="elementClick()">
  <div class="logo-part">
    <img
      class="playlist-img"
      [src]="playlist.images['512x512']"
      alt=""
      srcset="" />
  </div>
  <div class="playlist-title">{{ playlist.name }}</div>

  <div
    [ngClass]="
      playlist.id === selectedId && selected
        ? 'confirmation-container'
        : 'confirmation-container-hidden'
    ">
    <span
      class="confirmation icon icon-g-validate validate"
      (click)="addToPlaylistClick()"
      pRipple></span>
    <span class="confirmation icon icon-g-cancel cancel" pRipple></span>
  </div>
</div>
